import script from "./PostCombobox.vue?vue&type=script&setup=true&lang=js"
export * from "./PostCombobox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__